import { dataGradeCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGradeCircle = /*#__PURE__*/createIcon(dataGradeCircle)
export default IconGradeCircle
